export const PARTNERS = {
  PREMIUM: 'premium',
  GHC: 'GHC',
  MOSGORTUR: 'mosgortur',
  MOSGORTUR_MANAGER: 'mosgortur_manager',
  MOSGORTUR_PUBLIC: 'mosgortur_public',
  ALFA: 'alfa',
  SUTOCHNO: 'sutochno',
  TBANK: 'tbank',
  TRAVELBELKA: 'travelbelka',
  COSMOS_TRAVEL: 'cosmos_travel',
} as const;

export const PARTNER_IDS = {
  [PARTNERS.PREMIUM]: 1305,
  [PARTNERS.GHC]: 1186,
  [PARTNERS.MOSGORTUR]: 1297,
  [PARTNERS.MOSGORTUR_MANAGER]: 1306,
  [PARTNERS.MOSGORTUR_PUBLIC]: 1336,
  [PARTNERS.ALFA]: 1220,
  [PARTNERS.SUTOCHNO]: 1168,
  [PARTNERS.TBANK]: 1190,
  [PARTNERS.TRAVELBELKA]: 118,
  [PARTNERS.COSMOS_TRAVEL]: 1320,
} as const;

export type PartnerCode = (typeof PARTNERS)[keyof typeof PARTNERS];
